import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Enable PWA features (offline/deep-link refresh). Safe for prod.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Send Core Web Vitals to GA4 and track tel/mailto clicks
reportWebVitals((metric) => {
  try {
    if (!window.gtag) return;
    const value = metric.name === 'CLS' ? metric.value * 1000 : metric.value;
    window.gtag('event', metric.name, {
      value: Math.round(value),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      non_interaction: true,
    });
  } catch (error) {
    console.warn('Web Vitals tracking error:', error);
  }
});

const sendEvent = (name, params) => {
  try {
    if (window.gtag) {
      window.gtag('event', name, params);
    }
  } catch (error) {
    console.warn('GA4 event tracking error:', error);
  }
};

document.addEventListener('click', (e) => {
  try {
    const anchor = e.target.closest && e.target.closest('a');
    if (!anchor) return;
    const href = (anchor.getAttribute('href') || '').toLowerCase();
    if (href.startsWith('tel:')) {
      sendEvent('call_now', {
        link_url: href,
        link_text: (anchor.textContent || '').trim() || 'Call link',
        engagement_type: 'tel',
      });
    } else if (href.startsWith('mailto:')) {
      sendEvent('email_quote', {
        link_url: href,
        link_text: (anchor.textContent || '').trim() || 'Email link',
        engagement_type: 'mailto',
      });
    }
  } catch (error) {
    console.warn('Click tracking error:', error);
  }
});
